import Vue from "vue";
import Vuex from "vuex";
import cart from './modules/cart'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    cart
  },
  state: {
    location: {},
    locale: "it",
    color: {},
    userShowMenuHotel: -1,
    spinner:false
  },
  mutations: {
    SET_LOCATION(state, location) {
      state.location = location;
    },

    SET_LOCALE(state, locale) {
      state.locale = locale;
    },

    SET_USER_SHOW_MENU(state, value) {
      state.userShowMenuHotel = value;
    },

    SET_COLOR(state, color) {
      state.color = color;
    },

    SET_SPINNER(state, value) {
      state.spinner = value;
    },
  },
  getters: {
    location(state) {
      return state.location;
    },

    locale(state) {
      return state.locale;
    },

    color(state) {
      return state.locale;
    },

    userShowMenuHotel(state) {
      return state.userShowMenuHotel;
    },

    spinner(state) {
      return state.spinner;
    }
  },
  actions: {
    setLocation({commit}, location){
      commit("SET_LOCATION", location);
    },

    setLocale({commit}, locale){
      commit("SET_LOCALE", locale);
    },
    
    setColor({commit}, color){
      commit("SET_COLOR", color);
    },

    setUserShowMwnu({commit}, value){
      commit("SET_USER_SHOW_MENU", value);
    },

    updateSpinner({commit}, value){
      commit("SET_SPINNER", value);
    },
  }
});
